module.exports = __webpack_public_path__ + "img/China.fe43ae1a.png";